import CopyPasteHandler from "./handler";

export default {
    __init__: ['copyPaste'],
    copyPaste: ['type', CopyPasteHandler]
}